import { Text as TamaguiText, styled } from 'tamagui';

// Re-exported under the SAME name as Tamagui's own `Text` -- every real
// call site keeps writing `<Text ...>` exactly as before; only the
// IMPORT changes (from 'tamagui' to '@/components/text'), so this fixes
// the whole class of bug in one place instead of 95 individual edits.
//
// Root cause, confirmed by reading Tamagui's own source, not assumed:
// `Text` is the raw, font-agnostic primitive; `SizableText` (which
// Paragraph/Heading/every other real typography component in this app
// is built on) is the one that actually inherits the theme's font
// config. Bare `<Text>` therefore silently falls back to the browser/
// OS system font -- confirmed live: preview.tsx's footer line and
// threads.tsx's "Within ~N mi of you" line both rendered visibly
// off-brand (founder, 2026-09-16: "the font don't add up... ugly"),
// and grepping every screen + component turned up 95 more bare `<Text`
// call sites with the same gap, including TextLink and BackLink --
// two shared components used at 30+ call sites between them. Per the
// founder's own standing instruction ("everything I flag now, in the
// future, and before as well should be fixed for that class of issue
// across the app, not just in this instance"), this closes the gap at
// its source rather than patching each of the ~100 known instances by
// hand, and prevents every FUTURE bare `<Text>` from reopening it.
export const Text = styled(TamaguiText, {
  name: 'AppText',
  fontFamily: '$body',
  fontWeight: '$regular',
});
